import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { sendInvitationEmailsRequested } from 'features/users/actions';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* sendInvitationEmailsSaga(
  action: ReturnType<typeof sendInvitationEmailsRequested>
) {
  yield call(SignalingSocket.send, {
    event: 'sendInvitationEmails',
    data: {
      users: action.payload,
    },
  });

  yield call(notification, i18n.t('notifications:invitation_emails_sent'));
}
